export default __webpack_public_path__ + "static/SRUS P212 - Product Specifications & Technical Data-404ed8a8e1f25c83b98d51ab23432e61.pdf";